var OverviewTabMixin = {
    props: {
        overviewhash: {
            type: String,
            required: true,
        },
        more: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },

    created: function () {
        // this.fetch()
    },

    computed: {
        linkedtype() {
            return this.$store.getters.linkedtype;
        },
        linkedid() {
            return this.$store.getters.linkedid;
        },
    },
};

export default OverviewTabMixin;
